var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStdioBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.5 8.1665H10.5C9.21129 8.1665 8.16663 9.21117 8.16663 10.4998V45.4998C8.16663 46.7885 9.21129 47.8332 10.5 47.8332H45.5C46.7886 47.8332 47.8333 46.7885 47.8333 45.4998V10.4998C47.8333 9.21117 46.7886 8.1665 45.5 8.1665Z",
    fill: "#D1E6FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 8.1665H45.5C46.7891 8.1665 47.8333 9.21067 47.8333 10.4998V15.1665H8.16663V10.4998C8.16663 9.21067 9.21079 8.1665 10.5 8.1665Z",
    fill: "#3987F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3749 36.75H30.6249C29.4973 36.75 28.5833 37.6641 28.5833 38.7917C28.5833 39.9192 29.4973 40.8333 30.6249 40.8333H39.3749C40.5025 40.8333 41.4166 39.9192 41.4166 38.7917C41.4166 37.6641 40.5025 36.75 39.3749 36.75Z",
    fill: "#3987F8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.3227 29.3428L17.9386 21.4686C17.0749 20.7438 15.7871 20.8565 15.0623 21.7203C14.3375 22.584 14.4501 23.8718 15.3139 24.5966L24.698 32.4708C25.5617 33.1956 26.8495 33.0829 27.5743 32.2191C28.2991 31.3553 28.1865 30.0676 27.3227 29.3428Z",
    fill: "#3987F8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6985 29.3535L15.3145 37.2277C14.4507 37.9525 14.3381 39.2403 15.0628 40.104C15.7876 40.9678 17.0754 41.0805 17.9392 40.3557L27.3233 32.4815C28.187 31.7568 28.2997 30.469 27.5749 29.6052C26.8501 28.7414 25.5623 28.6287 24.6985 29.3535Z",
    fill: "#3987F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStdioBlue);
export default __webpack_public_path__ + "static/media/icon_stdio_blue.3030577a.svg";
export { ForwardRef as ReactComponent };